import { FileTextOutlined, ProductOutlined, UserOutlined, ProfileOutlined, FolderOutlined, AimOutlined } from '@ant-design/icons'
import { Menu } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom';
import { getItem } from '../utils';

const items = [
    getItem('设备管理', 'unitPage', <ProductOutlined />),
    getItem('订单记录', 'orderRecord', <FileTextOutlined />),
    getItem('操作记录', 'openHistory', <ProfileOutlined />),
    getItem('区域管理', 'areaManage', <AimOutlined />),
    getItem('权限管理', 'roleManage', <UserOutlined />, [
        getItem('用户管理', 'roleManage/userManage'),
        getItem('个人中心', 'roleManage/userCenter')
    ]),
    getItem('系统日志', 'systemLog', <FolderOutlined />, [
        getItem('登录日志', 'systemLog/loginLog'),
        getItem('请求日志', 'systemLog/requestLog')
    ]
    ),
]
const SiderBar = ({ collapsed }) => {
    // 导航栏跳转
    const navigate = useNavigate()
    const onClickNavigate = (nvg) => {          //antd menu组件默认传参
        console.log('点击导航栏：', nvg.key)
        navigate(nvg.key)
    }
    // 反向高亮
    const location = useLocation()
    const selectedkey = [location.pathname.slice(1)] //获取当前路由路径
    const openKeys = [location.pathname.split("/")[1]]; // 父路由路径
    return (
        <Menu
            mode="inline"
            theme="dark"
            onClick={onClickNavigate}
            selectedKeys={selectedkey}
            defaultOpenKeys={openKeys}
            inlineCollapsed={collapsed}
            items={items}
            style={{ height: '100%', borderRight: 0 }}>
        </Menu>
    )
}
export default SiderBar